import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { MotivoPerdaVendaSituacaoModule } from '../situacao';
import { MotivoPerdaVendaExibicaoFormModule } from '../exibicao';
import { MotivoPerdaVendaPLMFormModule } from '../plm';
import { MotivoPerdaVendaOportunidadeFormModule } from '../oportunidade/form/motivo-perda-venda-oportunidade-form.module';
import { MotivoPerdaVendaConcorrenteFormModule } from '../concorrente/form/motivo-perda-venda-concorrente-form.module';

import { MotivoPerdaVendaFormComponent} from './motivo-perda-venda-form.component';

@NgModule({
    imports: [
        SharedModule,
        MotivoPerdaVendaSituacaoModule,
        MotivoPerdaVendaExibicaoFormModule,
        MotivoPerdaVendaPLMFormModule,
        MotivoPerdaVendaOportunidadeFormModule,
        MotivoPerdaVendaConcorrenteFormModule
    ],
    declarations: [
        MotivoPerdaVendaFormComponent
    ],
    exports: [
        MotivoPerdaVendaFormComponent
    ]
})
export class MotivoPerdaVendaFormModule { }
